import { Observable } from 'rxjs';

import type {
  CountriesResponse,
  ExtendedApiResponse,
  SupportedDocumentsRequest,
  SupportedDocumentsResponse,
  BaseApiRequest
} from '@coin-depo-types';

export interface CountriesApi {

  getAllCountries(
    data: BaseApiRequest & { username?: string; client_token?: string }
  ): Observable<ExtendedApiResponse<CountriesResponse>>;

  getCountries(
    data: BaseApiRequest & { username?: string; client_token?: string }
  ): Observable<ExtendedApiResponse<CountriesResponse>>;

  getSupportedDocuments(
    data: SupportedDocumentsRequest
  ): Observable<ExtendedApiResponse<SupportedDocumentsResponse>>;
}